<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead> -->
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-select v-model="queryData.name" filterable clearable size="small" style="width:210px" placeholder="公司名称">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
						<!-- <el-input clearable v-model="queryData.name" size="small" style="width:210px" placeholder="请输入"></el-input> -->
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.cooperationState" clearable size="small" style="width:210px" placeholder="合作情况">
							<el-option label="跟进中" :value="1"></el-option>
							<el-option label="合作中" :value="2"></el-option>
							<el-option label="合作结束" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="userInfo.admin">
						<el-select v-model="queryData.userId" filterable clearable size="small" style="width:210px" placeholder="所属媒介">
							<el-option v-for="item in companyMediumOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['company:company:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['company:company:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<el-button type="primary" size="small" v-hasPermi="['company:company:add']" @click="addTableData" style="margin-bottom: 16px;"
				><i class="el-icon-plus"></i> 新增</el-button>
				<el-table :max-height="600" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table">
					<el-table-column prop="name" label="公司名称"></el-table-column>
					<el-table-column prop="" label="Sass媒体">
						<template slot-scope="scope">
							<div v-if="scope.row.isSass==1">是</div>
							<div v-if="scope.row.isSass==0">否</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="name" label="公司全称"></el-table-column>
					<el-table-column prop="address" label="公司地址" width="200">
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.address">
								<div class="ellipsis_2">{{scope.row.address}}</div>
							</el-tooltip>
						</template>
					</el-table-column> -->
					<el-table-column prop="account" label="账号"></el-table-column>
					<el-table-column prop="passWord" label="密码"></el-table-column>
					<el-table-column label="认证状态" width="120">
						<template slot-scope="scope">
							<div class="auditStatus" v-if="scope.row.authStatus==2">
								<div class="statusLabel"></div>
								<div>待审核</div>
							</div>
							<div class="auditStatus" v-if="scope.row.authStatus==3">
								<div class="statusLabel" style="background: #19B21E;"></div>
								<div>认证通过</div>
							</div>
							<div class="auditStatus" v-if="scope.row.authStatus==4">
								<div class="statusLabel" style="background: #FC474C;"></div>
								<div>认证失败</div>
							</div>
							<div class="auditStatus" v-if="scope.row.authStatus==1">
								<div class="statusLabel" style="background: #AAAAAA;"></div>
								<div style="color: #AAAAAA;">待上传</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="合作情况">
						<template slot-scope="scope">
							<div v-if="scope.row.cooperationState==1">跟进中</div>
							<div v-if="scope.row.cooperationState==2">合作中</div>
							<div v-if="scope.row.cooperationState==3">合作结束</div>
						</template>
					</el-table-column>
					<el-table-column prop="userName" label="所属媒介"></el-table-column>
					<el-table-column prop="" label="素材审核">
						<template slot-scope="scope">
							<div v-if="scope.row.isCheck==1">展示</div>
							<div v-if="scope.row.isCheck==0">不展示</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="notifyUrl" label="回调地址" width="200">
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.notifyUrl">
								<div class="ellipsis_2">{{scope.row.notifyUrl}}</div>
							</el-tooltip>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="notifySecret" label="回调secret"></el-table-column> -->
					<el-table-column prop="mediaKey" label="素材审核key" width="200">
						<template slot-scope="scope">
							<!-- <el-tooltip :content="scope.row.mediaKey">
								<div class="ellipsis_2">{{scope.row.mediaKey}}</div>
							</el-tooltip> -->
							<el-popover placement="top" trigger="hover">
								<div class="popoverName">{{scope.row.mediaKey}}</div>
								<span class="" slot="reference">{{scope.row.mediaKey}}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作">
						<template slot-scope="scope">
							<div>
								<el-button type="text" size="small" v-hasPermi="['company:company:edit']" @click="editTable(scope.row)">编辑</el-button>
								<el-button type="text" size="small" v-hasPermi="['company:company:mediaManage']" @click="mediaManage(scope.row)">应用管理</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-drawer @close="closeDrawer" :visible.sync="companyDrawerShow" size="48%" :wrapperClosable="false"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">公司信息</div>
					<i class="el-icon-circle-close" @click="companyDrawerShow=false"></i>
				</div>
				<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" 
				:model="companyFormData" ref="ruleCompanyForm">
					<el-form-item label="公司简称：" prop="nickName">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.nickName"></el-input>
					</el-form-item>
					<el-form-item label="公司全称：" prop="name">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.name"></el-input>
					</el-form-item>
					<el-form-item label="公司地址：" prop="address">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.address"></el-input>
					</el-form-item>
					<el-form-item label="合同时间">
						<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
							start-placeholder="起始日期" end-placeholder="结束日期" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="合同编号：">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.contractNumber"></el-input>
					</el-form-item>
					<el-form-item label="合作情况：" prop="cooperationState">
						<el-select v-model="companyFormData.cooperationState" clearable size="small">
							<el-option label="跟进中" :value="1"></el-option>
							<el-option label="合作中" :value="2"></el-option>
							<el-option label="合作结束" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属媒介：" prop="userId">
						<el-select v-model="companyFormData.userId" filterable clearable size="small">
							<el-option v-for="item in companyMediumOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="素材审核：" prop="isCheck">
						<el-radio v-model="companyFormData.isCheck" :label="1">展示</el-radio>
						<el-radio v-model="companyFormData.isCheck" :label="0">不展示</el-radio>
					</el-form-item>
					<el-form-item label="审核维度：" prop="checkType">
						<el-radio v-model="companyFormData.checkType" :label="1">公司维度</el-radio>
						<el-radio v-model="companyFormData.checkType" :label="2">APP维度</el-radio>
					</el-form-item>
					<el-form-item label="媒体账号：">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.account"></el-input>
					</el-form-item>
					<el-form-item label="媒体密码：">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.passWord"></el-input>
					</el-form-item>
					<el-form-item label="联系人：">
						<el-input clearable size="small" disabled placeholder="请输入" v-model="companyFormData.contacts"></el-input>
					</el-form-item>
					<el-form-item label="联系电话：">
						<el-input clearable size="small" disabled placeholder="请输入" v-model="companyFormData.phone"></el-input>
					</el-form-item>
					<el-form-item label="资质编号：">
						<el-input clearable size="small" disabled placeholder="请输入" v-model="companyFormData.number"></el-input>
					</el-form-item>
					<el-form-item label="营业执照" size="small">
						<el-image v-if="companyFormData.businessPhotoUrl" :src="companyFormData.businessPhotoUrl" 
						:preview-src-list="[companyFormData.businessPhotoUrl]"></el-image>
						<!-- <img class="businessLicenseImg" v-if="companyFormData.businessPhotoUrl" :src="companyFormData.businessPhotoUrl" alt="" /> -->
						<div class="businessLicenseTips" v-else>
							<img src="../../assets/images/businessLicenseTips.png" alt="" />
						</div>
					</el-form-item>
					
					
					<el-form-item label="开户银行：">
						<el-input clearable size="small" disabled placeholder="请输入" v-model="companyFormData.bankAccountName"></el-input>
					</el-form-item>
					<el-form-item label="开户账号：">
						<el-input clearable size="small" disabled placeholder="请输入" v-model="companyFormData.bankAccount"></el-input>
					</el-form-item>
					<el-form-item label="开票内容：">
						<el-select v-model="companyFormData.invoiceContent" clearable size="small">
							<el-option v-for="item in invoiceContSelect" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税点：">
						<el-select v-model="companyFormData.taxPoint" clearable size="small">
							<el-option v-for="item in taxPointSelect" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="回调地址：">
						<el-input clearable size="small" placeholder="请输入" v-model="companyFormData.notifyUrl"></el-input>
					</el-form-item>
					<div class="card-bottom flex_end">
						<el-button @click="companyDrawerShow=false" size="medium">取消</el-button>
						<el-button type="primary" @click="confirmCompany('ruleCompanyForm')" size="medium">确定</el-button>
					</div>
				</el-form>
			</el-card>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '公司管理',
				hasPermiDict: 'company:company:add',
				companyDrawerShow: false,
				queryData: {},//列表查询条件
				companyOptions: [], // 公司下拉选择列表
				tableData: [],
				datePicker: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi:{
					nickName: [{required: true,message: '请输入公司简称',trigger: 'blur'}],//公司简称
					name: [{required: true,message: '请输入公司全称',trigger: 'blur'}],//公司全称
					cooperationState: [{required: true,message: '请选择合作情况',trigger: 'blur'}],//合作情况
					userId: [{required: true,message: '请选择所属媒介',trigger: 'blur'}],//所属情况
				},
				companyFormData:{
					invoiceContent: 1,
					taxPoint: 6,
					isCheck: 0,
					checkType: 1
				},
				// 开票内容下拉选择
				invoiceContSelect: [
					{value:1,label:'广告发布费'},
					{value:2,label:'信息服务费'},
				], 
				// 税点下拉选择
				taxPointSelect: [
					{value:1,label:'1%'},
					{value:3,label:'3%'},
					{value:6,label:'6%'},
				],
				companyMediumOptions: [],// 所属媒介选择列表
				userInfo: {}
			}
		},
		activated(){
			this.getTableData();
		},
		mounted() {
			if(sessionStorage.getItem('sdk-userinfo')){
				this.userInfo = JSON.parse(sessionStorage.getItem('sdk-userinfo'))
			}
			this.getCompanyOption();
			this.getCompanyMediumOption();
		},
		methods: {
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取公司所属媒介选择列表
			async getCompanyMediumOption() {
				let res = await this.$http.get(this.$api.common.companyMediumOption,{flag:1});
				this.companyMediumOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				data = {...data,...this.queryData}
				let res = await this.$http.post(this.$api.companyList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			handleSizeChange(val){
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val){
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {
					name: '',
					cooperationState: '',
					userId: '',
				}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			addTableData(){
				this.$router.push({
					path: '/companyEdit',
					query: {
						sideId: 2
					}
				})
				// this.companyFormData = {
				// 	invoiceContent: 1,
				// 	taxPoint: 6,
				// 	isCheck: 0,
				// 	checkType: 1
				// },
				// this.datePicker = []
				// this.companyDrawerShow = true
			},
			editTable(row) {
				this.$router.push({
					path: '/companyEdit',
					query: {
						sideId: 2,
						id: row.id
					}
				})
				// this.companyFormData = JSON.parse(JSON.stringify(row))
				// if(row.contractStartDate&&row.contractEndDate){
				// 	this.datePicker.push(row.contractStartDate)
				// 	this.datePicker.push(row.contractEndDate)
				// }
				// this.companyDrawerShow = true
			},
			closeDrawer(){
				this.companyDrawerShow = false
			},
			confirmCompany(formName){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.companyFormData;
						if(data.invoiceContent == 1){
							data['invoiceDiff'] = '0'
						}
						if(data.invoiceContent == 2){
							data['invoiceDiff'] = '1.5'
						}
						if(data.taxPoint == 1){
							data['valueAddDiff'] = '5'
						}
						if(data.taxPoint == 3){
							data['valueAddDiff'] = '3'
						}
						if(data.taxPoint == 6){
							data['valueAddDiff'] = '0'
						}
						if(this.datePicker.length>0){
							data['contractStartDate'] = this.datePicker[0]
							data['contractEndDate'] = this.datePicker[1]
						}
						if(data.id){
							let res = await this.$http.post(this.$api.companyEdit, data);
							if(res.code==1){
								this.$message.success('修改成功');
							}
						}else{
							let res = await this.$http.post(this.$api.companyAdd, data);
							if(res.code==1){
								this.$message.success('新增成功');
							}
						}
						this.closeDrawer();
						this.getTableData();
					}
				});
			},
			mediaManage(row) {
				this.$router.push({
					path: '/aggregation/applicationManage',
					query: {
						sideId: 32,
						name: row.name,
					}
				})
			}
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}
	
	.popoverName{
		font-size: 12px;
		text-align: center;
	}

	.el-form {}
	
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}
	.auditStatus {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}

	.menu-right {
		margin-left: auto;
	}
	.cardTitle{
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}
	.cardTitle i{
		cursor: pointer;
	}
	.cardTitleTxt{
		font-size: 16px;
	}
	.box-card{
		height: 100%;
	}
	.box-card /deep/ .el-form--inline{
		overflow-y: auto;
	}
	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}
	.box-card /deep/ .el-card__body{
		height: 90%;
		overflow-y: auto !important;
		box-sizing: border-box;
	}
	.card-bottom{
		padding-right: 30px;
	}
	/deep/ .el-drawer__body{
		height: 100%;
	}
	.el_dialog_form /deep/ .el-form-item{
		margin-right: 0;
	}
	
	
	.businessLicenseTips{
		width: 120px;
		height: 120px;
		border-radius: 4px;
		border: 1px solid #DBDFE3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.businessLicenseTips img{
		width: 56px;
		height: 56px;
	}
	.businessLicenseImg{
		width: 120px;
		height: 120px;
	}
</style>